import { Component, Inject } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { APP_WINDOW, AppWindow } from '../AppWindow';
import { OktaAuth } from '@okta/okta-auth-js';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent {
  constructor(
    @Inject(APP_WINDOW) private _window: AppWindow,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
  ) {}

  public signIn(): void {
    this._window.location.pathname = '/idp-configurations';
  }
}
